








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
@Component({
  components: {},
})
export default class Box1 extends Vue {
  type: any = 2;
  entInfo: any = [];
  entInfo2: any = [];
  total: any = 0;
  total2: any = 0;
  mounted() {
    this.getData({});
  }

  getData(opts: any) {
    zyScreenServer
      .getRegulatedEntityCount({})
      .then((res: any) => {
        res.data.forEach((item: any) => {
          if (item.type === 'NINE_SMALL_PLACE') {
            this.entInfo2 = item.industryCountList;
            this.total2 = item.num;
          }
          if (item.type === 'COMPANY') {
            this.entInfo = item.industryCountList;
            this.total = item.num;
          }
        });
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  getPoint(entType: any, hyType: any) {
    zyScreenServer
      .getDrawList({
        companyPlaceType: entType,
        industry: hyType,
      })
      .then((res: any) => {
        this.$emit('setEntPoint', res.data);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
}
